import initReleases from '~/releases';

document.addEventListener('DOMContentLoaded', initReleases);
